<mat-drawer-container class="drawer-container" style="overflow: hidden !important;">
    <div class="content">
        <app-header></app-header>
            <app-sub-header [screen]="'Buscando en '+screen" ></app-sub-header>
            <app-template [screen]="screen" [ids]="id" *ngIf="!flag"></app-template>
            <app-teachers *ngIf="flag"></app-teachers>
        <app-footer></app-footer>
    </div>
</mat-drawer-container>
